import {createStore} from 'redux'
import updateReducer from './reducers/updateReducer'

export default createStore(updateReducer)